import { ArrowLeft } from 'lucide-react'
import { LoadingSpinner } from '@/features/common/components/LoadingSpinner'
import { useKeysSettingsViewModel } from '../viewmodels/use_keys_settings_viewmodel'

export function KeysPageView() {
  const {
    fcmKey,
    twilioAccountSid,
    twilioAuthToken,
    errors,
    isSubmitting,
    isLoading,
    setFcmKey,
    setTwilioAccountSid,
    setTwilioAuthToken,
    setErrors,
    handleSubmit,
    handleCancel,
  } = useKeysSettingsViewModel()

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <button
            onClick={handleCancel}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-5 h-5 text-gray-600" />
          </button>
          <div>
            <h1 className="text-2xl font-semibold text-gray-800">Keys Management</h1>
          </div>
        </div>
        <div className="flex items-center justify-center h-64">
          <LoadingSpinner size="lg" />
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <button
          onClick={handleCancel}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
        <div>
          <h1 className="text-2xl font-semibold text-gray-800">Keys Management</h1>
        </div>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* FCM Key */}
          <div>
            <label htmlFor="fcmKey" className="block text-sm font-medium text-gray-700 mb-2">
              FCM Key<span className="text-red-500">*</span>
            </label>
            <input
              id="fcmKey"
              type="text"
              value={fcmKey}
              onChange={e => {
                setFcmKey(e.target.value)
                setErrors(prev => ({ ...prev, fcmKey: undefined }))
              }}
              placeholder="Enter FCM Key"
              className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 ${
                errors.fcmKey ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.fcmKey && <p className="mt-1 text-sm text-red-600">{errors.fcmKey}</p>}
          </div>

          {/* Twilio Account SID */}
          <div>
            <label
              htmlFor="twilioAccountSid"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Twilio Account SID<span className="text-red-500">*</span>
            </label>
            <input
              id="twilioAccountSid"
              type="text"
              value={twilioAccountSid}
              onChange={e => {
                setTwilioAccountSid(e.target.value)
                setErrors(prev => ({ ...prev, twilioAccountSid: undefined }))
              }}
              placeholder="Enter Twilio Account SID"
              className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 ${
                errors.twilioAccountSid ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.twilioAccountSid && (
              <p className="mt-1 text-sm text-red-600">{errors.twilioAccountSid}</p>
            )}
          </div>

          {/* Twilio Auth Token */}
          <div>
            <label
              htmlFor="twilioAuthToken"
              className="block text-sm font-medium text-gray-700 mb-2"
            >
              Twilio Auth Token<span className="text-red-500">*</span>
            </label>
            <input
              id="twilioAuthToken"
              type="password"
              value={twilioAuthToken}
              onChange={e => {
                setTwilioAuthToken(e.target.value)
                setErrors(prev => ({ ...prev, twilioAuthToken: undefined }))
              }}
              placeholder="Enter Twilio Auth Token"
              className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 ${
                errors.twilioAuthToken ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.twilioAuthToken && (
              <p className="mt-1 text-sm text-red-600">{errors.twilioAuthToken}</p>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex items-center justify-end gap-4 pt-4 border-t border-gray-200">
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-6 py-2 text-sm font-medium text-white rounded-md hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ backgroundColor: '#019b9a' }}
            >
              {isSubmitting ? (
                <span className="flex items-center gap-2">
                  <LoadingSpinner size="sm" />
                  Saving...
                </span>
              ) : (
                'Save'
              )}
            </button>
            <button
              type="button"
              onClick={handleCancel}
              className="px-6 py-2 text-sm font-medium text-gray-700 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

